import 'bootstrap';
import '../../scss/stylesheet.scss';
import './actionList';
import './Bootgrid/initBootgrids';
import './cardList';
import './config';
import './confirmation';
import './editGrid';
import './emptyGuid';
import './excelReport';
import './form';
import './initializer';
import './initSummernote';
import './jobNotifications';
import './luscinia';
import './modal/modal';
import './notifications';
import './overrides';
import './parameter';
import './postValueChanged';
import './record';
import './select2';
import './gridSplitter';
import './topMenuDropdownSearch';
import './translation';
import './updateJobOverview';
import './utility';
import './validator';
import './wizard';
import './email';
import './dynamicRequiredForm';
import './StagedIntervalConfigurator/StagedIntervalConfigurator';
import './apiRequestWithNotification';
import './testEnvironment';
import './Agenda/agenda'
import './Agenda/timeLine'
import './Utils/handleRecordSave';
import './sendReportEmail';
import './downloadReportEmail';
import './initFormElements';
import './initMultiSelect2';
import './Rentvision';
import './parameters/render-parameter-modal';
import './Bootgrid/multi-select-input';
import './modal/faqModal-search';
import { luscinia } from './luscinia';

(window as any).luscinia = luscinia;